import Member from '../components/Member';
import Job from '../components/Job';
import React from 'react';
import JobDetailsRecruiter from '../components/features/recruiter/JobDetailsRecruiter';
import Recruiter from '../components/Recruiter';
import Splash from '../components/Splash';
import Registration from '../components/Registration';
import Login from '../components/Login';
import ResetPassword from '../components/ResetPassword';
import VerifyMobileNumber from '../components/VerifyMobileNumber';
import Four0Four from '../components/Four0Four';
import Verification from '../components/Verification';
import Client from '../components/Client';
import VerifyEmail from '../components/VerifyEmail';
import EmailVerified from '../components/EmailVerified';
import JoinMember from '../components/JoinMember';
import EmailReset from '../components/EmailReset';
import ChangePassword from '../components/ChangePassword';
import PasswordUpdated from '../components/PasswordUpdated';
import JobResponse from '../components/JobResponse';
import InviteMember from '../components/features/recruiter/InviteMember';
import InviteSuccess from '../components/features/recruiter/InviteSuccess';
import JobDetailsClient from '../components/features/client/JobDetailsClient';
import HistoryDetail from '../components/HistoryDetail';
import JobPostSuccess from '../components/features/client/JobPostSuccess';
import JobDraftSuccess from '../components/features/client/JobDraftSuccess';
import Members from '../components/features/recruiter/Members';
import ApplyClientNotify from '../components/features/client/ApplyClientNotify';
import JobApplicants from '../components/features/client/JobApplicants/JobApplicants';
import ReadOnlyJob from '../components/features/client/readOnlyJob';
import EditJob from '../components/features/client/EditJob';
import ViewProfile from '../components/features/client/JobApplicants/ViewProfile';
import JobRejectors from '../components/features/client/JobRejectors';
import FAQs from '../components/features/client/FAQs';
import CallBackPopUp from '../components/CallBackPopup';
import TermsOfServices from '../components/TermsOfServices';
import CogenRegistrationTermOfServices from '../components/CogenRegistrationTermOfServices';
import PrivacyPolicy from '../components/PrivacyPolicy';
import ClientDetails from '../components/features/recruiter/ClientDetails';
import AddNewJob from '../components/features/client/AddNewJob';
import ClientRegistration from '../components/features/RegistrationModule/ClientRegistration';
import VerificationModal from '../components/features/RegistrationModule/VerificationModal';
import MemberRegistration from '../components/features/RegistrationModule/MemberRegistration';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ClinetPlans from '../pages/clinetPlans';
import MmemberPlans from '../pages/memberPlans';

export const Routess = {
	client: [
		{ path: '/', element: <Client /> },

		{ path: '/jobs/create', element: <AddNewJob /> },
		{ path: '/job/:id/rejectors', element: <JobRejectors /> },
		{ path: '/job/:id', element: <JobDetailsClient /> },
		{
			path: '/apply-client-notify/member/:memberId/job/:id',
			element: <ApplyClientNotify />,
		},
		{ path: '/job/:id/applicants', element: <JobApplicants /> },
		// { path:"/job/:id/view", element: JobApplicants },
		{ path: '/job/:id/:type', element: <JobApplicants /> },
		{ path: '/:id/edit-job', element: <EditJob /> },
		{ path: '/jobs/:id', element: <ReadOnlyJob /> },
		{ path: '/job/:id/applicants/view-profile', element: <ViewProfile /> },
		{ path: '/job/:id/rejectors', element: <JobRejectors /> },
		{ path: '/job/:id/faqs', element: <FAQs /> },
		{ path: '/job-post-success', element: <JobPostSuccess /> }, // Dashboard
		{ path: '/job-draft-success', element: <JobDraftSuccess /> }, // Dashboard
	],
	member: [
		{ path: '/', element: <Member /> }, // Dashboard
		{ path: '/job/:id', element: <Job /> },
		{ path: '/job/:id/:type', element: <Job /> },
		{ path: '/job-history/:id', element: <HistoryDetail /> },
		{ path: '/job/:id/response', element: <JobResponse /> },
	],
	recruiter: [
		{ path: '/', element: <Recruiter /> },
		{ path: '/invite-member', element: <InviteMember /> },
		{ path: '/job/:id', element: <JobDetailsRecruiter /> },
		{ path: '/invite-success', element: <InviteSuccess /> },
		{ path: '/members', element: <Members /> },
		{ path: '/client-details', element: <ClientDetails /> },
	],
	public: [
		{ path: '/callback/twitter', element: <CallBackPopUp /> },
		{ path: '/client-plans', element: <ClinetPlans /> },
		{ path: '/member-plans', element: <MmemberPlans /> },
		{ path: '/callback/linkedin', element: <CallBackPopUp /> },
		{ path: '/', element: <Splash /> }, // Landing Page
		{ path: '/registration', element: <Registration /> },
		{ path: '/login', element: <Login /> },
		{ path: '/subscribe', element: <Login /> },
		{ path: '/forgot-password', element: <ResetPassword /> },
		{ path: '/change-password/:token', element: <ChangePassword /> },
		{ path: '/password-updated', element: <PasswordUpdated /> },
		{ path: '/email-reset', element: <EmailReset /> },
		{ path: '/verification/:token', element: <Verification /> },
		{ path: '/verify-email', element: <VerifyEmail /> },
		{ path: '/verified-email/:token', element: <EmailVerified /> },
		{ path: '/join-member/:token', element: <JoinMember /> },
		{ path: '/terms-of-services', element: <TermsOfServices /> },
		{ path: '/termsOfServices', element: <CogenRegistrationTermOfServices /> },
		{ path: '/privacy-policy', element: <PrivacyPolicy /> },
		{ path: '/client_registration', element: <ClientRegistration /> },
		{ path: '/verificationModal', element: <VerificationModal /> },
		{ path: '/member_registration', element: <MemberRegistration /> },

		{ path: '/verify-mobile', element: <VerifyMobileNumber /> },
		{ path: '*', element: <Four0Four /> },
	],
};
